import { DELETE_INVITATION, SET_INVITATIONS, SET_LOADING, SET_NOTIFICATION_MESSAGE, SET_NOTIFICATION_TYPE, SET_SELECTED_PROJECT_ID, TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG, TOGGLE_SHOW_NOTIFICATION, TOGGLE_SHOW_REJECT_INVITATION_DIALOG, UPDATE_INVITATION } from "./InvitationEvents";

export const initialInvitationState = {
    invitations: {},
    loading: true,
    showRejectInvitationDialog: false,
    showAcceptInvitationDialog: false,
    selectedProjectId: null,
    noticationType: "error",
    showNotification: false,
    notificationMessage: "",
};

export const InvitationReducer = (state, action) => {
    switch (action.type) {
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            };
        }
        case SET_INVITATIONS: {
            return {
                ...state,
                invitations: action.payload
            };
        }
        case UPDATE_INVITATION: {
            return {
                ...state,
                invitations: {
                    ...state.invitations,
                    masterProjects: state.invitations.masterProjects.map((project) => {
                        if (project.masterProjectId === action.payload.id) {
                            return {
                                ...project,
                                ...action.payload.data
                            }
                        }
                        return project;
                    })
                }
            }
        }
        case DELETE_INVITATION: {
            return {
                ...state,
                invitations: {
                    ...state.invitations,
                    masterProjects: state.invitations.masterProjects.filter((project) => project.masterProjectId !== action.payload)
                }
            }
        }
        case TOGGLE_SHOW_REJECT_INVITATION_DIALOG: {
            return {
                ...state,
                showRejectInvitationDialog: !state.showRejectInvitationDialog
            };
        }
        case TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG: {
            return {
                ...state,
                showAcceptInvitationDialog: !state.showAcceptInvitationDialog
            };
        }
        case SET_SELECTED_PROJECT_ID: {
            return {
                ...state,
                selectedProjectId: action.payload
            };
        }
        case SET_NOTIFICATION_MESSAGE: {
            return {
                ...state,
                notificationMessage: action.payload
            };
        }
        case TOGGLE_SHOW_NOTIFICATION: {
            return {
                ...state,
                showNotification: !state.showNotification
            };
        }
        case SET_NOTIFICATION_TYPE: {
            return {
                ...state,
                noticationType: action.payload
            };
        }
        default:
            return state;
    }
}